import _ from 'lodash';

/*
 * Nested field errors shuld be provided with a path notation as shown in the tests
 */
export const getFieldErrors = data => {
  let errors = {};

  data.errors
    .filter(error => !_.isNil(error.field) && error.field !== '__all__')
    .forEach(error => {
      _.set(errors, error.field, error.message);
    });

  return errors;
};

export const getFormErrors = data =>
  data.errors
    .filter(error => _.isNil(error.field) || error.field === '__all__')
    .map(error => error.message);

export const getErrors = data => {
  const nonFieldErrors = getFormErrors(data);
  let fieldErrors: any = getFieldErrors(data);

  if (!_.isEmpty(nonFieldErrors)) {
    fieldErrors._error = nonFieldErrors;
  }

  return fieldErrors;
};
